// GENERATED FILE, PLEASE DO NOT EDIT
export var ButtonDefault = 'Rectangle';